import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useDeleteApplicationScreenshotMutation} from '../hooks/useApplicationScreenshotsQuery';
import {useApplicationScreenshotsSelection} from "../hooks/useApplicationScreenshotsSelection.ts";


export const DeleteRecordButton = () => {

    const deleteApplicationScreenshotMutation = useDeleteApplicationScreenshotMutation();

    const {
        selection,
        handleClearSelection,
    } = useApplicationScreenshotsSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleDelete = async () => {
        for (const id of recordIds) {
            await deleteApplicationScreenshotMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);

};
